export function handleCloseSurveyOnDialog() {
  const dialog = document.querySelector("dialog[open]");

  if (!dialog) return null;

  return dialog.querySelector("button[aria-label*='fechar' i]");
}
